// tslint:disable:max-line-length

import React from 'react';

export const UtilityComments = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M0 0v11l3-3h2v-5h5v-3h-10zm6 4v8h7l3 3v-11h-10z" />
    </svg>
  );
};
